import "core-js/modules/es.promise.js";
import React from 'react';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { componentsSingleFileStatus } from "../../components";
export const DropSingleFileStatus = props => {
  const {
    drop,
    common,
    camera,
    components = componentsSingleFileStatus,
    status
  } = props;
  const {
    open
  } = drop;
  const {
    value,
    disabled,
    onChange
  } = common;
  const {
    setFile,
    remove,
    removeRejected
  } = status;
  const {
    DefaultView = componentsSingleFileStatus.DefaultView,
    AcceptedView = componentsSingleFileStatus.AcceptedView,
    RejectedView = componentsSingleFileStatus.RejectedView
  } = components;
  if (value !== null && value !== void 0 && value.accepted) {
    return /*#__PURE__*/React.createElement(AcceptedView, {
      accepted: value.accepted,
      open: open,
      remove: remove,
      disabled: disabled
    });
  } else if (value !== null && value !== void 0 && value.rejected && value.rejected.length) {
    return /*#__PURE__*/React.createElement(RejectedView, {
      rejected: value.rejected,
      open: open,
      remove: removeRejected,
      disabled: disabled
    });
  } else {
    return /*#__PURE__*/React.createElement(Slug, {
      config: {
        tension: 100,
        friction: 10
      },
      from: {
        opacity: 0,
        transform: 'translate3d(0px,50px,0)'
      }
    }, /*#__PURE__*/React.createElement(DefaultView, {
      open: open,
      disabled: disabled,
      camera: camera,
      onFile: setFile
    }));
  }
};